// extracted by mini-css-extract-plugin
export default {"flexGrid":"XC7vwJ1G_MGIbneYaTbS","flexTwo":"PBl8LSt1h2qxVUhblH6r","pageContainer":"rde6UOFbiYmSSw3R7rVW","boxes":"N6AUYttLm7tVm6fPYyp5"};